import { makeStyles,useTheme } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme=>({
  wrapper: {
    margin: '30px 0',
    
  },
  title: {
    margin: '0 0 12px',
   [theme.breakpoints.down('sm')]:{
    textAlign: 'center'
   }
  }
}));
